/**
 * Feature 14 — Activation page consumed by an approved claimant via a
 * 7-day token mailed by admin after setup-org.
 */
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { directoryApi } from '../services/directory';


export default function ActivatePage() {
  const { token = '' } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const mutation = useMutation({
    mutationFn: () => directoryApi.activate({ token, password }),
    onSuccess: () => {
      navigate('/login', { replace: true });
    },
  });

  const mismatch = password !== confirm && confirm.length > 0;
  const disabled = mutation.isPending || password.length < 8 || mismatch;

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow border border-slate-200 max-w-md w-full p-6">
        <h1 className="text-xl font-semibold text-slate-900">
          Activate your account
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Set a password to finish signup. This activation link expires in
          7 days.
        </p>
        <div className="mt-5 space-y-3">
          <label className="block">
            <span className="text-xs font-medium text-slate-600">Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-lg border-2 border-slate-200 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
            />
          </label>
          <label className="block">
            <span className="text-xs font-medium text-slate-600">Confirm password</span>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mt-1 w-full rounded-lg border-2 border-slate-200 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
            />
          </label>
          {mismatch && (
            <p className="text-xs text-red-600">Passwords don't match.</p>
          )}
          {mutation.isError && (
            <p className="text-xs text-red-600">
              Invalid or expired activation link.
            </p>
          )}
        </div>
        <button
          onClick={() => mutation.mutate()}
          disabled={disabled}
          className="mt-6 w-full rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 hover:bg-brand-600"
        >
          {mutation.isPending ? 'Activating…' : 'Activate'}
        </button>
      </div>
    </div>
  );
}
